import { useContext, useEffect, useState } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

export function useBlocker(blocker: () => boolean) {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const [pendingTx, setPendingTx] = useState<any>(null);

  useEffect(() => {

    const push = navigator.push;
    const replace = navigator.replace;

    const blockerWrapper = (...args: Parameters<typeof push>) => {
      const tx = { retry: () => push(...args) };
      if (blocker())
        setPendingTx(tx);
      else
        tx.retry()
    };

    navigator.push = blockerWrapper;
    navigator.replace = blockerWrapper;

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [navigator, blocker]);

  const handleStay = () => {
    setPendingTx(null); // cancel navigation
  };

  const handleLeave = () => {
    if (pendingTx) {
      pendingTx.retry(); // resume navigation
      setPendingTx(null);
    }
  };

  return {
    handleStay,
    handleLeave,
  }
}